var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('b-icon',{attrs:{"icon":"three-dots","animation":"cylon","variant":"success","font-scale":"4"}}),_c('p',[_vm._v(_vm._s(_vm.overlayText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }